var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTool6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4254_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8157 5.19569V34.3624C24.8157 37.6259 27.0673 39.4444 29.4558 39.4444C31.6654 39.4444 34.096 37.8977 34.096 34.3624V5.41665C34.096 2.42486 31.8864 0.555542 29.4558 0.555542C27.0253 0.555542 24.8157 2.61709 24.8157 5.19569Z",
    fill: "#F9AB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.663 20V34.3624C12.663 37.626 14.9145 39.4445 17.3031 39.4445C19.5127 39.4445 21.9433 37.8977 21.9433 34.3624V20.221C21.9433 17.2292 19.7337 15.3599 17.3031 15.3599C14.8726 15.3599 12.663 17.4214 12.663 20Z",
    fill: "#E37400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15028 39.4444C7.71297 39.4444 9.79043 37.3669 9.79043 34.8042C9.79043 32.2415 7.71297 30.1641 5.15028 30.1641C2.5876 30.1641 0.510132 32.2415 0.510132 34.8042C0.510132 37.3669 2.5876 39.4444 5.15028 39.4444Z",
    fill: "#E37400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4254_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.9394,
    height: 40,
    fill: "white",
    transform: "translate(0.333374)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool6);
export default __webpack_public_path__ + "static/media/tool-6.748532325ec6db388295b1f942557313.svg";
export { ForwardRef as ReactComponent };